module.exports = __webpack_public_path__ + "img/Siu.c69dd491.jpg";